import React from "react";
import sendButtonIcon from "../../assets/sendbutton.svg";

const SendIcon: React.FC = () => (
  <img src={sendButtonIcon} alt="" aria-hidden="true" width="20" height="20" />
);

export default SendIcon;
